export default {
  path: '/quality_foci',
  name: 'quality_foci',
  component: () => import('../components/qualityfocus/Layout'),
  redirect: { name: 'QualityFocusList' },
  meta: {
    breadcrumb: 'profile.quality.focus',
  },
  children: [
    {
      name: 'QualityFocusList',
      path: '',
      component: () => import('../views/qualityfocus/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'QualityFocusCreate',
      path: 'new',
      component: () => import('../views/qualityfocus/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'QualityFocusUpdate',
      path: ':id/edit',
      component: () => import('../views/qualityfocus/Update'),
      meta: {
        breadcrumb: 'profile.quality.focusname',
      },
    },
    {
      name: 'QualityFocusShow',
      path: ':id',
      component: () => import('../views/qualityfocus/Show'),
      meta: {
        breadcrumb: 'profile.quality.focusname',
      },
    }
  ]
};
